export const LISTAR_EMPRESAS_COM_PGR_EMITIDO =
  "LISTAR_EMPRESAS_COM_PGR_EMITIDO";
